/**
 * Mapeia tipo de forma de pagamento (xpro4) → bloco de documentação oficial.
 * Textos vêm de i18n: paymentMethodsPage.docs.<chave>.*
 */

const H = {
  CIELO_ONBOARDING: "https://docs.cielo.com.br/ecommerce-cielo/docs/onbording-api-ecommerce",
  CIELO_REVOKE_CREDS:
    "https://docs.cielo.com.br/ecommerce-cielo/reference/revogar-e-criar-credenciais-no-site-cielo",
  CIELO_ENABLE_METHODS:
    "https://docs.cielo.com.br/atendimento/docs/como-habilitar-uma-integra%C3%A7%C3%A3o-com-meios-de-pagamento",
  CIELO_MICROSERVICES:
    "https://docs.cielo.com.br/ecommerce-cielo/docs/como-habilitar-microsservi%C3%A7os",
  CIELO_PIX: "https://docs.cielo.com.br/ecommerce-cielo/docs/pix",
  CIELO_PIX_CREATE_PAYMENT:
    "https://docs.cielo.com.br/ecommerce-cielo/reference/qrcode-pix",
  CIELO_ENABLE_PIX: "https://docs.cielo.com.br/ecommerce-cielo/docs/como-habilitar-pix",
  CIELO_GATEWAY_PIX_CIELO2: "https://docs.cielo.com.br/gateway/docs/pix-cielo",
  CIELO_GATEWAY_PIX_LEGACY: "https://docs.cielo.com.br/gateway/docs/pix",
  CIELO_PIX_SETTINGS: "https://docs.cielo.com.br/ecommerce-cielo/docs/configura%C3%A7%C3%B5es-pix",
  CIELO_ARCH:
    "https://docs.cielo.com.br/ecommerce-cielo-en/reference/environments-and-api-architecture",
  CIELO_MANUAL_APIPIX: "https://desenvolvedores.cielo.com.br/api-portal/pt-br/content/api-pix",
  BRADESCO_API_PIX_PDF:
    "https://assets.bradesco/content/dam/portal-bradesco/pix/assets/docs/api_pix_200.pdf",
  BRASPAG_MANUAL: "https://docs.cielo.com.br/gateway/docs/gateway",
  MP_CREDENTIALS: "https://www.mercadopago.com.br/developers/pt/docs/your-integrations/credentials",
  MP_CHECKOUT: "https://www.mercadopago.com.br/developers/pt/docs/checkout-pro/create-application",
  ITAU_PIX_API:
    "https://devportal.itau.com.br/nossas-apis/itau-ep9-gtw-pix-recebimentos-ext-v2?tab=especificacaoTecnica",
  ITAU_AUTH: "https://devportal.itau.com.br/autenticacao-documentacao",
  ITAU_CERT: "https://devportal.itau.com.br/certificado-dinamico",
  REDE_DEV: "https://developer.userede.com.br/e-rede",
  ADYEN_CREDS: "https://docs.adyen.com/development-resources/api-credentials",
  ADYEN_LINKS: "https://docs.adyen.com/online-payments/build-your-integration/payment-links/",
  PAGARME_DOCS: "https://docs.pagar.me/reference/visao-geral-da-api-1",
  APPMAX_DOCS: "https://docs.appmax.com.br/",
};

/** @typedef {{ i18nPrefix: string, bullets?: string[], links: { labelSuffix: string, href: string }[] }} DocDef */

/** @type {Record<string, DocDef>} */
const DOCS = {
  cieloCheckout: {
    i18nPrefix: "paymentMethodsPage.docs.cieloCheckout",
    bullets: ["b1", "b2", "b3"],
    links: [
      { labelSuffix: "linkOnboarding", href: H.CIELO_ONBOARDING },
      { labelSuffix: "linkEnableMethods", href: H.CIELO_ENABLE_METHODS },
      { labelSuffix: "linkArch", href: H.CIELO_ARCH },
    ],
  },
  cieloApi: {
    i18nPrefix: "paymentMethodsPage.docs.cieloApi",
    bullets: ["b1", "b2", "b3"],
    links: [
      { labelSuffix: "linkRevogar", href: H.CIELO_REVOKE_CREDS },
      { labelSuffix: "linkOnboarding", href: H.CIELO_ONBOARDING },
      { labelSuffix: "linkEnableMethods", href: H.CIELO_ENABLE_METHODS },
    ],
  },
  cieloPortal: {
    i18nPrefix: "paymentMethodsPage.docs.cieloPortal",
    bullets: ["b1", "b2", "b3"],
    links: [
      { labelSuffix: "linkMicroservices", href: H.CIELO_MICROSERVICES },
      { labelSuffix: "linkOnboarding", href: H.CIELO_ONBOARDING },
      { labelSuffix: "linkEnableMethods", href: H.CIELO_ENABLE_METHODS },
    ],
  },
  cieloGateway: {
    i18nPrefix: "paymentMethodsPage.docs.cieloGateway",
    bullets: ["b1", "b2", "b3"],
    links: [
      { labelSuffix: "linkBraspag", href: H.BRASPAG_MANUAL },
      { labelSuffix: "linkOnboarding", href: H.CIELO_ONBOARDING },
      { labelSuffix: "linkEnableMethods", href: H.CIELO_ENABLE_METHODS },
    ],
  },
  cieloPixApi: {
    i18nPrefix: "paymentMethodsPage.docs.cieloPixApi",
    bullets: ["b1", "b2", "b3"],
    links: [
      { labelSuffix: "linkCreatePayment", href: H.CIELO_PIX_CREATE_PAYMENT },
      { labelSuffix: "linkPix", href: H.CIELO_PIX },
      { labelSuffix: "linkEnablePix", href: H.CIELO_ENABLE_PIX },
      { labelSuffix: "linkPixSettings", href: H.CIELO_PIX_SETTINGS },
      { labelSuffix: "linkRevogar", href: H.CIELO_REVOKE_CREDS },
    ],
  },
  cieloPixPortal: {
    i18nPrefix: "paymentMethodsPage.docs.cieloPixPortal",
    bullets: ["b1", "b2", "b3", "b4"],
    links: [
      { labelSuffix: "linkPix", href: H.CIELO_PIX },
      { labelSuffix: "linkMicroservices", href: H.CIELO_MICROSERVICES },
      { labelSuffix: "linkPixSettings", href: H.CIELO_PIX_SETTINGS },
      { labelSuffix: "linkOnboarding", href: H.CIELO_ONBOARDING },
    ],
  },
  cieloPixGateway: {
    i18nPrefix: "paymentMethodsPage.docs.cieloPixGateway",
    bullets: ["b1", "b2", "b3", "b4", "b5"],
    links: [
      { labelSuffix: "linkGatewayPix", href: H.CIELO_GATEWAY_PIX_CIELO2 },
      { labelSuffix: "linkGatewayPixLegacy", href: H.CIELO_GATEWAY_PIX_LEGACY },
      { labelSuffix: "linkBraspag", href: H.BRASPAG_MANUAL },
      { labelSuffix: "linkPix", href: H.CIELO_PIX },
      { labelSuffix: "linkPixSettings", href: H.CIELO_PIX_SETTINGS },
      { labelSuffix: "linkRevogar", href: H.CIELO_REVOKE_CREDS },
    ],
  },
  cieloPixApi2: {
    i18nPrefix: "paymentMethodsPage.docs.cieloPixApi2",
    bullets: ["b1", "b2", "b3", "b4"],
    links: [
      { labelSuffix: "linkManual", href: H.CIELO_MANUAL_APIPIX },
      { labelSuffix: "linkPixSettings", href: H.CIELO_PIX_SETTINGS },
    ],
  },
  cieloPixBradesco: {
    i18nPrefix: "paymentMethodsPage.docs.cieloPixBradesco",
    bullets: ["b1", "b2", "b3", "b4"],
    links: [
      { labelSuffix: "linkBradescoManual", href: H.BRADESCO_API_PIX_PDF },
      { labelSuffix: "linkEnablePix", href: H.CIELO_ENABLE_PIX },
      { labelSuffix: "linkPixSettings", href: H.CIELO_PIX_SETTINGS },
    ],
  },
  mercadoPago: {
    i18nPrefix: "paymentMethodsPage.docs.mercadoPago",
    bullets: ["b1", "b2", "b3"],
    links: [
      { labelSuffix: "linkCreds", href: H.MP_CREDENTIALS },
      { labelSuffix: "linkCheckout", href: H.MP_CHECKOUT },
    ],
  },
  itauPix: {
    i18nPrefix: "paymentMethodsPage.docs.itauPix",
    bullets: ["b1", "b2", "b3"],
    links: [
      { labelSuffix: "linkPortal", href: H.ITAU_PIX_API },
      { labelSuffix: "linkAuth", href: H.ITAU_AUTH },
      { labelSuffix: "linkCertificate", href: H.ITAU_CERT },
    ],
  },
  rede: {
    i18nPrefix: "paymentMethodsPage.docs.rede",
    bullets: ["b1", "b2"],
    links: [{ labelSuffix: "linkDev", href: H.REDE_DEV }],
  },
  adyen: {
    i18nPrefix: "paymentMethodsPage.docs.adyen",
    bullets: ["b1", "b2", "b3"],
    links: [
      { labelSuffix: "linkCreds", href: H.ADYEN_CREDS },
      { labelSuffix: "linkLinks", href: H.ADYEN_LINKS },
    ],
  },
  pagarme: {
    i18nPrefix: "paymentMethodsPage.docs.pagarme",
    bullets: ["b1", "b2"],
    links: [{ labelSuffix: "linkDocs", href: H.PAGARME_DOCS }],
  },
  buspay: {
    i18nPrefix: "paymentMethodsPage.docs.buspay",
    bullets: ["b1", "b2"],
    links: [],
  },
  pagueFacil: {
    i18nPrefix: "paymentMethodsPage.docs.pagueFacil",
    bullets: ["b1", "b2"],
    links: [],
  },
  appmaxLink: {
    i18nPrefix: "paymentMethodsPage.docs.appmaxLink",
    bullets: ["b1", "b2"],
    links: [{ labelSuffix: "linkDocs", href: H.APPMAX_DOCS }],
  },
  appmaxPix: {
    i18nPrefix: "paymentMethodsPage.docs.appmaxPix",
    bullets: ["b1", "b2"],
    links: [{ labelSuffix: "linkDocs", href: H.APPMAX_DOCS }],
  },
  appmaxCard: {
    i18nPrefix: "paymentMethodsPage.docs.appmaxCard",
    bullets: ["b1", "b2"],
    links: [{ labelSuffix: "linkDocs", href: H.APPMAX_DOCS }],
  },
  defaultManual: {
    i18nPrefix: "paymentMethodsPage.docs.defaultManual",
    bullets: ["b1"],
    links: [],
  },
  cash: {
    i18nPrefix: "paymentMethodsPage.docs.cash",
    bullets: ["b1"],
    links: [],
  },
  legacyOther: {
    i18nPrefix: "paymentMethodsPage.docs.legacyOther",
    bullets: ["b1", "b2"],
    links: [],
  },
};

/**
 * @param {number} tipo
 * @param {{ cieloKind?: string }} [opts]
 * @returns {{ sectionTitleKey: string, titleKey: string, bulletKeys: string[], links: { labelKey: string, href: string }[] } | null}
 */
export function getPaymentMethodDocConfig(tipo, opts = {}) {
  const n = Number(tipo);
  const cieloKind = String(opts.cieloKind || "ec_api");

  let def = null;
  switch (n) {
    case 3:
      def = DOCS.cieloCheckout;
      break;
    case 6:
      def = DOCS.mercadoPago;
      break;
    case 7:
      // Xpay: só habilitar no cadastro; sem painel de documentação no formulário
      return null;
    case 8:
      def = DOCS.itauPix;
      break;
    case 9:
      def = DOCS.rede;
      break;
    case 10:
      def = DOCS.adyen;
      break;
    case 11:
      def = DOCS.appmaxLink;
      break;
    case 12:
      def = DOCS.appmaxPix;
      break;
    case 13:
      def = DOCS.appmaxCard;
      break;
    case 14:
      if (cieloKind === "gateway") def = DOCS.cieloGateway;
      else if (cieloKind === "ec_portal") def = DOCS.cieloPortal;
      else def = DOCS.cieloApi;
      break;
    case 15:
      if (cieloKind === "gateway") def = DOCS.cieloPixGateway;
      else if (cieloKind === "ec_portal") def = DOCS.cieloPixPortal;
      else if (cieloKind === "pix_api2") def = DOCS.cieloPixApi2;
      else if (cieloKind === "bradesco_pix") def = DOCS.cieloPixBradesco;
      else def = DOCS.cieloPixApi;
      break;
    case 0:
      def = DOCS.defaultManual;
      break;
    case 5:
      def = DOCS.cash;
      break;
    case 1:
      def = DOCS.buspay;
      break;
    case 2:
      def = DOCS.pagarme;
      break;
    case 4:
      def = DOCS.pagueFacil;
      break;
    default:
      return null;
  }

  if (!def) return null;

  const p = def.i18nPrefix;
  return {
    sectionTitleKey: "paymentMethodsPage.docs.sectionTitle",
    titleKey: `${p}.title`,
    bulletKeys: (def.bullets || []).map((b) => `${p}.${b}`),
    links: (def.links || []).map((l) => ({
      labelKey: `${p}.${l.labelSuffix}`,
      href: l.href,
    })),
  };
}
